import { get, post, put } from '../client'
import {
  PublicationFilterParamsSchema,
  PaginationParamsSchema,
  type Publication,
  type PublicationCategory,
  type PublicationFilterParams,
  type PublicationStats,
  type ApiResponse,
  type PaginatedResponse,
  type PaginationParams,
  CreatePublication,
  CreatePublicationSchema,
  UpdatePublication,
  UpdatePublicationSchema
} from '../types'

export class PublicationService {

  async getPublications(
    params: PaginationParams = { page: 1, size: 10 },
    filters: PublicationFilterParams = {}
  ): Promise<ApiResponse<PaginatedResponse<Publication>>> {
    const validatedParams = PaginationParamsSchema.parse(params)
    const validatedFilters = PublicationFilterParamsSchema.parse(filters)

    const query = new URLSearchParams({
      page: validatedParams.page.toString(),
      size: validatedParams.size.toString()
    }).toString()

    return await post<ApiResponse<PaginatedResponse<Publication>>>(
      `publications/private/filter?${query}`,
      validatedFilters
    )
  }


  async getPublicationStats(): Promise<ApiResponse<PublicationStats>> {
    // Get counts for published and draft publications
    const [publishedResponse, draftResponse] = await Promise.all([
      this.getPublications({ page: 1, size: 1 }, { status: 'PUBLISH' }),
      this.getPublications({ page: 1, size: 1 }, { status: 'DRAFT' })
    ])

    const stats: PublicationStats = {
      publishedPublications: publishedResponse.data?.totalOfAllElements || 0,
      draftPublications: draftResponse.data?.totalOfAllElements || 0,
      totalPublications: (publishedResponse.data?.totalOfAllElements || 0) + (draftResponse.data?.totalOfAllElements || 0)
    }

    return {
      success: true,
      message: 'Stats retrieved successfully',
      data: stats
    }
  }


  async getPublicationById(publicationId: string): Promise<ApiResponse<Publication>> {
    return await get<ApiResponse<Publication>>(
      `publications/private/${publicationId}`
    )
  }

  async createPublication(data: CreatePublication): Promise<ApiResponse<Publication>> {

    const validationData = CreatePublicationSchema.parse(data)

    return await post<ApiResponse<Publication>>(
      'publications/admin/private',
      validationData
    )
  };

  async updatePublication(publicationId:string, data:UpdatePublication ): Promise<ApiResponse<Publication>>{

    const validationData = UpdatePublicationSchema.parse(data)

    return await put<ApiResponse<Publication>>(
      `publications/admin/private/${publicationId}`,
      validationData
    )
  }


  async deletePublication(publicationId: string): Promise<ApiResponse<null>> {
    // TODO: Implement when delete endpoint is available
    console.log(publicationId)
    return Promise.resolve({
      success: true,
      message: 'Delete functionality not implemented yet',
      data: null
    })
  }

  async getPublicationCategories(): Promise<ApiResponse<PublicationCategory[]>> {
    return await get<ApiResponse<PublicationCategory[]>>(
      'publications/private/categories'
    )
  }
}


export const publicationService = new PublicationService()

// Export default
export default publicationService
